import { Expose, plainToInstance, Transform } from 'class-transformer';
import { DrupalIdentifier, DrupalNode } from '@nx-icilalune/drupal-types';
import { UIDate } from './ui.model';

export class NewsLink {
  @Transform(({ obj }) => {
    return obj?.title;
  })
  @Expose()
  title!: string;

  @Transform(({ obj }) => {
    return obj?.uri;
  })
  @Expose()
  url!: string;
}

export class News extends DrupalNode {
  public static readonly type = 'articles';

  /*@Transform(({ obj }) => {
    return `/${obj?.attributes?.langcode}${obj?.attributes?.path?.alias}`;
  })
  @Expose()
  path?: string;*/

  @Transform(({ obj }) => {
    if (obj?.attributes?.date_only) {
      const date: UIDate = {
        value: obj?.attributes?.date_only,
        format: 'date-formats.medium',
      };
      return date;
    }
    return undefined;
  })
  @Expose()
  date!: UIDate | undefined;

  @Transform(({ obj }) => {
    return obj?.attributes?.summary;
  })
  @Expose()
  override summary!: string;

  @Transform(({ obj }) => {
    const links: any[] = obj?.attributes?.field_links;
    if (links) {
      return links.map((link) => {
        return plainToInstance(NewsLink, link, {
          excludeExtraneousValues: true,
          exposeUnsetFields: false,
        });
      });
    }
    return [];
  })
  @Expose()
  links!: NewsLink[];

  /****** RELATIONSHIPS ******/

  @Transform(({ obj }) => {
    return obj?.relationships?.media?.data || undefined;
  })
  @Expose()
  media!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.paragraphs?.data || undefined;
  })
  @Expose()
  paragraphs: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.field_client?.data || undefined;
  })
  @Expose()
  client!: DrupalIdentifier;

  @Transform(({ obj }) => {
    return obj?.relationships?.associated_projects?.data || undefined;
  })
  @Expose()
  associated!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.attributes?.list_item_text_preview || undefined;
  })
  @Expose()
  textPreview!: string | undefined;
}
